import { withInstall } from '@chenms-zj/utils/with-install'
import InputNumber from './src/input-numbers.vue'

export const CmsInputNumber = withInstall(InputNumber)
export default CmsInputNumber

export * from './src/input-number'
